import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ChevronDown_xl = (props) => {
    const width = props.width ? props.width + 'px' : '40px';
    const height = props.height ? props.height + 'px' : '40px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.31606 11.2705C4.71897 10.8927 5.35181 10.9131 5.72954 11.3161L20 26.5379L34.2705 11.3161C34.6482 10.9131 35.281 10.8927 35.6839 11.2705C36.0869 11.6482 36.1073 12.281 35.7295 12.6839L20.7295 28.6839C20.5405 28.8856 20.2764 29 20 29C19.7236 29 19.4595 28.8856 19.2705 28.6839L4.27047 12.6839C3.89274 12.281 3.91315 11.6482 4.31606 11.2705Z"
            />
        </SvgStyled>
    );
};

export default ChevronDown_xl;
